import { Trash2 } from 'lucide-react';
import Modal from './Modal';

interface DeleteAddressModalProps {
  isOpen: boolean;
  deleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

function DeleteAddressModal({ isOpen, deleting, onClose, onConfirm }: DeleteAddressModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Delete Address" dismissible={!deleting}>
      <p style={{ marginBottom: '20px' }}>
        Are you sure you want to delete this address? This action cannot be undone.
      </p>
      <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
        <button className="btn btn-ghost" onClick={onClose} disabled={deleting}>
          Cancel
        </button>
        <button className={`btn btn-danger ${deleting ? 'loading' : ''}`} onClick={onConfirm} disabled={deleting}>
          <Trash2 size={16} />
          {deleting ? 'Deleting...' : 'Delete'}
        </button>
      </div>
    </Modal>
  );
}

export default DeleteAddressModal;
